import React, { useState } from 'react';
import { Employee, LeaveBalance } from '../../shared/types.js';
import Modal from './Modal';
import LeaveBalanceCard from './LeaveBalanceCard';
import LeaveDetailsModal from './LeaveDetailsModal';

interface LeaveBalancesModalProps {
    isOpen: boolean;
    onClose: () => void;
    employee: Employee | null;
}

const LeaveBalancesModal: React.FC<LeaveBalancesModalProps> = ({ isOpen, onClose, employee }) => {
    const [isLeaveDetailsModalOpen, setIsLeaveDetailsModalOpen] = useState(false);
    const [selectedLeaveBalance, setSelectedLeaveBalance] = useState<LeaveBalance | null>(null);

    if (!isOpen || !employee) {
        return null;
    }

    const handleLeaveCardClick = (balance: LeaveBalance) => {
        setSelectedLeaveBalance(balance);
        setIsLeaveDetailsModalOpen(true);
    };

    const handleDetailsClose = () => {
        setIsLeaveDetailsModalOpen(false);
        setSelectedLeaveBalance(null);
    }

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} title={`Leave Balances for ${employee.firstName} ${employee.lastName}`}>
                {employee.leaveBalances && employee.leaveBalances.length > 0 ? (
                    <div className="flex flex-wrap justify-center gap-4 py-4">
                        {employee.leaveBalances.map((balance, index) => (
                            <LeaveBalanceCard
                                key={`${balance.leaveTypeId}-${balance.fromDate}`}
                                balance={balance}
                                index={index}
                                onClick={() => handleLeaveCardClick(balance)}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="text-center p-8 text-gray-500 dark:text-gray-400">
                        This employee has no leave balances to display.
                    </div>
                )}
            </Modal>

            {selectedLeaveBalance && (
                <LeaveDetailsModal
                    isOpen={isLeaveDetailsModalOpen}
                    onClose={handleDetailsClose}
                    employeeId={employee.id}
                    balance={selectedLeaveBalance}
                />
            )}
        </>
    );
};

export default LeaveBalancesModal;
